import "bootstrap/dist/css/bootstrap.min.css"
import * as bootstrap from "bootstrap"

window.bootstrap = bootstrap
